import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { generatePath, Link } from 'react-router'

import { Descriptions, Flex, Typography } from 'antd'

import { Country } from '../../components/icon/Country'
import routes, { generateSlug } from '../../routes'

const Entry: FC<{ year: string; country: string; name: string; time: string; speed: string }> = ({
  year,
  country,
  name,
  speed,
  time,
}) => {
  return (
    <Flex justify={'space-between'} style={{ width: '100%' }}>
      <Flex gap={8} align={'center'}>
        <Typography.Text code>{year}</Typography.Text>
        <Country height={16} country={country} />
        <Link
          to={generatePath(routes.rider, {
            slug: generateSlug(name),
          })}
        >
          {name}
        </Link>
      </Flex>
      <Typography.Text>{time ? `${time} (${[speed, 'km/h'].join(' ')})` : [speed, 'km/h'].join(' ')}</Typography.Text>
    </Flex>
  )
}

const Records: FC<{ record: MotoGP.TrackRecord }> = ({ record }) => {
  return (
    <Descriptions
      layout={'vertical'}
      size={'small'}
      column={1}
      items={[
        {
          label: <FormattedMessage id={'track.record.circuit-record'} />,
          children: (
            <Entry
              year={record.circuitRecord.year}
              country={record.circuitRecord.rider.country.iso}
              name={record.circuitRecord.rider.full_name}
              time={record.circuitRecord.time}
              speed={record.circuitRecord.speed}
            />
          ),
        },
        {
          label: <FormattedMessage id={'track.record.fastest-lap'} />,
          children: (
            <Entry
              year={record.fastestLap.year}
              country={record.fastestLap.rider.country.iso}
              name={record.fastestLap.rider.full_name}
              time={record.fastestLap.time}
              speed={record.fastestLap.speed}
            />
          ),
        },
        {
          label: <FormattedMessage id={'track.record.best-pole-time'} />,
          children: (
            <Entry
              year={record.bestPole.year}
              country={record.bestPole.rider.country.iso}
              name={record.bestPole.rider.full_name}
              time={record.bestPole.time}
              speed={record.bestPole.speed}
            />
          ),
        },
        {
          label: <FormattedMessage id={'track.record.top-speed'} />,
          children: (
            <Entry
              year={record.topSpeed.year}
              country={record.topSpeed.rider.country.iso}
              name={record.topSpeed.rider.full_name}
              time={''}
              speed={record.topSpeed.speed}
            />
          ),
        },
      ]}
    />
  )
}

export { Records }
